import React, { useEffect, useMemo, useState } from 'react';
import { PresentationPreflight } from './preflight';
import { useParams } from 'react-router-dom';
import { BwjViewManager, BwjViewState } from '../../../../framework/components/bwj-view-manager';
import { xlate, xlationContext } from '../../../../framework/utils/i18n';
import { PresentationApiClient } from '../../../../services/presentation';
import * as formService from '../../form-services/presentation-editor';
import * as prefsFormService from '../../../presenter-account/form-services/account-preferences';
import { GetPresentationForEditingResponse } from '../../../../entities-generated/models/presentation/get-presentation-for-editing-response';
import { PresentationInflight } from './inflight';
import { useStandardResourceNotFoundState } from '../../../../entities/view-manager-standard/resource-not-found';
import { useStandardErrorState } from '../../../../entities/view-manager-standard/error';

xlationContext('Presentation preflight page');

const subscriberId = 'Page.PresentationPage';

export const PresentationPage: React.FunctionComponent = () => {
  const { id: presentationId } = useParams<{id: string}>();
  const [viewState, setViewState] = useState(BwjViewState.Loading);
  const [inFlight, setInFlight] = useState(false);
  const errorState = useStandardErrorState();
  const pageNotFoundState = useStandardResourceNotFoundState();
  const prefsFormModel = prefsFormService.useFormModel(subscriberId);
  const prefs = useMemo(() => {
    return prefsFormService.toRequest();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prefsFormModel]);

  useEffect(() => {
    PresentationApiClient.getPresentation(presentationId)
    .then(model => {
      const dataModel = new GetPresentationForEditingResponse();
      dataModel.model = model;
      formService.initializeService(dataModel);
      setInFlight(model.inProgress);
      setViewState(BwjViewState.Ready);
    })
    .catch((statusCode) => {
      if(statusCode === 404) {
        setViewState(BwjViewState.PageNotFound);
      } else {
        setViewState(BwjViewState.Error);
      }
    });
  }, [presentationId]);

  const onReadyToFly = () => {
    setInFlight(true);
    
    const id = formService.id.getOutputValue();
    const request = formService.toStartPresentationRequest();
    PresentationApiClient.startPresentation(id, request)
    .catch(() => {});
  };

  return (
    <BwjViewManager
      state={viewState}
      loadingState={{ message: xlate('Preparing discussion...') }}
      errorState={errorState}
      pageNotFoundState={pageNotFoundState}
    >
      {inFlight ?
      <PresentationInflight
        accountPreferences={prefs}
      />
      :
      <PresentationPreflight
        accountPreferences={prefs}
        onReadyToFly={onReadyToFly}
      />}
    </BwjViewManager>
  );
};
